const FILTER_OPTIONS = {};

// Step 34, owner's order: what kind of business the client is. These three
// words belong to the page, not to the records; the record field they are
// matched against is "Applicant Types".
const BUSINESS_TYPE = {};
BUSINESS_TYPE['Non-Profit'] = true;
BUSINESS_TYPE['For-Profit'] = true;
BUSINESS_TYPE['Individual'] = true;
BUSINESS_TYPE['School / University'] = true;
BUSINESS_TYPE['Government / Public Agency'] = true;

FILTER_OPTIONS['Business Type'] = BUSINESS_TYPE;

const AGENCY_TYPE = {};
AGENCY_TYPE['Federal'] = true;
AGENCY_TYPE['State'] = true;
// Owner, 2026-09-05: a foundation grant is one of three kinds — Foundation
// (the record only says foundation, or does not say which kind), Private
// Foundation (built from an IRS 990-PF filing) and Public Foundation (built
// from an IRS 990 or 990-EZ filing). The program matches the three kinds
// exactly, so ticking Foundation no longer brings back the private and the
// public ones.
AGENCY_TYPE['Foundation'] = true;
AGENCY_TYPE['Private Foundation'] = true;
AGENCY_TYPE['Public Foundation'] = true;
AGENCY_TYPE['Corporation'] = true;
AGENCY_TYPE['Local'] = true;
// Step 18: British government grants. Their records read "UK Government".
AGENCY_TYPE['UK Government'] = true;

FILTER_OPTIONS['Agency Type'] = AGENCY_TYPE;

const CATEGORIES = {};
CATEGORIES['Aging/Seniors'] = true;
CATEGORIES['Arts and Culture'] = true;
CATEGORIES['Awards'] = true;
CATEGORIES['BIPOC'] = true;
CATEGORIES['Business'] = true;
CATEGORIES['Capital Funding'] = true;
CATEGORIES['Children'] = true;
CATEGORIES['Climate Change'] = true;
CATEGORIES['College Scholarship'] = true;
CATEGORIES['Community Services'] = true;
CATEGORIES['Community/Economic Development'] = true;
CATEGORIES['Conflict Resolution'] = true;
CATEGORIES['Coronavirus COVID-19'] = true;
CATEGORIES['Disabilities'] = true;
CATEGORIES['Disaster Relief'] = true;
CATEGORIES['Domestic Violence'] = true;
CATEGORIES['Education'] = true;
CATEGORIES['Elementary Education'] = true;
CATEGORIES['Energy'] = true;
CATEGORIES['Environment'] = true;
CATEGORIES['Faith Based'] = true;
CATEGORIES['Farming/Agriculture'] = true;
CATEGORIES['Financial Assistance'] = true;
CATEGORIES['HIV/AIDS'] = true;
CATEGORIES['Health and Medical'] = true;
CATEGORIES['Higher Education'] = true;
CATEGORIES['Homeland & National Security'] = true;
CATEGORIES['Homeless'] = true;
CATEGORIES['Housing'] = true;
CATEGORIES['Individual'] = true;
CATEGORIES['International'] = true;
CATEGORIES['Justice & Juvenile Justice'] = true; //32
CATEGORIES['Literacy & Libraries'] = true;
CATEGORIES['Mental Health'] = true;
CATEGORIES['Municipalities'] = true;
CATEGORIES['Non-Profit Support Services'] = true;
CATEGORIES['Nutrition'] = true;
CATEGORIES['Other'] = true;
CATEGORIES['Pets/Animal/Wildlife'] = true;
CATEGORIES['Preschool'] = true;
CATEGORIES['Preservation'] = true;
CATEGORIES['Quality of Life'] = true;
CATEGORIES['Refugee/Immigrant'] = true;
CATEGORIES['Research & Evaluation'] = true;
CATEGORIES['Science'] = true;
CATEGORIES['Secondary Education'] = true;
CATEGORIES['Small Business'] = true;
CATEGORIES['Social Justice'] = true;
CATEGORIES['Special Education'] = true;
CATEGORIES['Sports & Recreation'] = true;
CATEGORIES['Students'] = true;
CATEGORIES['Substance Abuse'] = true;
CATEGORIES['Teachers'] = true;
CATEGORIES['Technology'] = true;
CATEGORIES['Transportation'] = true;
CATEGORIES['Travel & Tourism'] = true;
CATEGORIES['Veterans'] = true;
CATEGORIES['Women'] = true;
CATEGORIES['Workforce'] = true;
CATEGORIES['Youth/Out-of-School Youth'] = true;

FILTER_OPTIONS['Categories'] = CATEGORIES;

const GEOGRAPHIC_FOCUS = {};
GEOGRAPHIC_FOCUS['Alabama'] = true;
GEOGRAPHIC_FOCUS['Alberta'] = true;
GEOGRAPHIC_FOCUS['Awaswas'] = true;
GEOGRAPHIC_FOCUS['Beaver'] = true;
GEOGRAPHIC_FOCUS['Broward'] = true;
GEOGRAPHIC_FOCUS['Bucks'] = true;
GEOGRAPHIC_FOCUS['California'] = true;
GEOGRAPHIC_FOCUS['Canada'] = true;
GEOGRAPHIC_FOCUS['Cattaraugus'] = true;
GEOGRAPHIC_FOCUS['Chalon'] = true;
GEOGRAPHIC_FOCUS['Chautauqua'] = true;
GEOGRAPHIC_FOCUS['Chester'] = true;
GEOGRAPHIC_FOCUS['Columbia'] = true;
GEOGRAPHIC_FOCUS['DC'] = true;
GEOGRAPHIC_FOCUS['Erie'] = true;
GEOGRAPHIC_FOCUS['Puerto Rico (USA)'] = true;
GEOGRAPHIC_FOCUS['Virgin Islands (USA)'] = true;
GEOGRAPHIC_FOCUS['San Benito'] = true;
GEOGRAPHIC_FOCUS['San Francisco'] = true;
GEOGRAPHIC_FOCUS['San Mateo'] = true;
GEOGRAPHIC_FOCUS['Santa Cruz'] = true;
GEOGRAPHIC_FOCUS['Marshall Islands (USA)'] = true;
GEOGRAPHIC_FOCUS['Republic of Palau (USA)'] = true;
GEOGRAPHIC_FOCUS['The Federated States of Micronesia (USA)'] = true;
GEOGRAPHIC_FOCUS['USA'] = true;
GEOGRAPHIC_FOCUS['USA Compact Free Associations'] = true;
GEOGRAPHIC_FOCUS[' USA Territories'] = true;
GEOGRAPHIC_FOCUS['  Alaska'] = true;
GEOGRAPHIC_FOCUS['  Arizona'] = true;
GEOGRAPHIC_FOCUS['  Arkansas'] = true;
GEOGRAPHIC_FOCUS['  British Columbia'] = true;
GEOGRAPHIC_FOCUS['  Colorado'] = true;
GEOGRAPHIC_FOCUS['  Connecticut'] = true;
GEOGRAPHIC_FOCUS['  Delaware'] = true;
GEOGRAPHIC_FOCUS['  Florida'] = true;
GEOGRAPHIC_FOCUS['  Georgia'] = true;
GEOGRAPHIC_FOCUS['  Hawaii'] = true;
GEOGRAPHIC_FOCUS['  Idaho'] = true;
GEOGRAPHIC_FOCUS['  Illinois'] = true;
GEOGRAPHIC_FOCUS['  Indiana'] = true;
GEOGRAPHIC_FOCUS['  Iowa'] = true;
GEOGRAPHIC_FOCUS['  Kansas'] = true;
GEOGRAPHIC_FOCUS['  Kentucky'] = true;
GEOGRAPHIC_FOCUS['  Louisiana'] = true;
GEOGRAPHIC_FOCUS['  Maine'] = true;
GEOGRAPHIC_FOCUS['  Manitoba'] = true;
GEOGRAPHIC_FOCUS['  Maryland'] = true;
GEOGRAPHIC_FOCUS['  Massachusetts'] = true;
GEOGRAPHIC_FOCUS['  Michigan'] = true;
GEOGRAPHIC_FOCUS['  Minnesota'] = true;
GEOGRAPHIC_FOCUS['  Mississippi'] = true;
GEOGRAPHIC_FOCUS['  Missouri'] = true;
GEOGRAPHIC_FOCUS['  Montana'] = true;
GEOGRAPHIC_FOCUS['  Nebraska'] = true;
GEOGRAPHIC_FOCUS['  Nevada'] = true;
GEOGRAPHIC_FOCUS['  New Brunswick'] = true;
GEOGRAPHIC_FOCUS['  New Hampshire'] = true;
GEOGRAPHIC_FOCUS['  New Jersey'] = true;
GEOGRAPHIC_FOCUS[' New Mexico'] = true;
GEOGRAPHIC_FOCUS['  New York'] = true;
GEOGRAPHIC_FOCUS['  New York City'] = true;
GEOGRAPHIC_FOCUS['  Newfoundland and Labrador'] = true;
GEOGRAPHIC_FOCUS['  North Carolina'] = true;
GEOGRAPHIC_FOCUS['  North Dakota'] = true;
GEOGRAPHIC_FOCUS['  Northwest Territories'] = true;
GEOGRAPHIC_FOCUS['  Nova Scotia'] = true;
GEOGRAPHIC_FOCUS['  Nunavut'] = true;
GEOGRAPHIC_FOCUS['  Ohio'] = true;
GEOGRAPHIC_FOCUS['  Oklahoma'] = true;
GEOGRAPHIC_FOCUS['  Oregon'] = true;
GEOGRAPHIC_FOCUS['  Pennsylvania'] = true;
GEOGRAPHIC_FOCUS['  Prince Edward Island'] = true;
GEOGRAPHIC_FOCUS['  Quebec'] = true;
GEOGRAPHIC_FOCUS['  Rhode Island'] = true;
GEOGRAPHIC_FOCUS['  Saskatchewan'] = true;
GEOGRAPHIC_FOCUS['  South Carolina'] = true;
GEOGRAPHIC_FOCUS['  South Dakota'] = true;
GEOGRAPHIC_FOCUS['  Tennessee'] = true;
GEOGRAPHIC_FOCUS['  Texas'] = true;
GEOGRAPHIC_FOCUS['  Utah'] = true;
GEOGRAPHIC_FOCUS['  Vermont'] = true;
GEOGRAPHIC_FOCUS['  Virginia'] = true;
GEOGRAPHIC_FOCUS['  Washington'] = true;
GEOGRAPHIC_FOCUS['  West Virginia'] = true;
GEOGRAPHIC_FOCUS['  Wisconsin'] = true;
GEOGRAPHIC_FOCUS['  Wyoming'] = true;
GEOGRAPHIC_FOCUS['  Yukon'] = true;

FILTER_OPTIONS['Geographic Focus'] = GEOGRAPHIC_FOCUS;

export default FILTER_OPTIONS;
